import type { LucideIcon } from 'lucide-react'

export interface StatCardProps {
  icon: LucideIcon
  label: string
  value: string | number
  hint?: string
  tone?: 'primary' | 'accent' | 'danger' | 'gray'
  onClick?: () => void
}

const TONES = {
  primary: 'bg-primary-soft text-primary',
  accent: 'bg-accent-soft text-accent-text',
  danger: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-300',
  gray: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
}

/** The counters on top of Home and the lists ("is anything wrong?" before the table). */
export function StatCard({ icon: Icon, label, value, hint, tone = 'primary', onClick }: StatCardProps) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`stat-card text-left ${onClick ? 'cursor-pointer hover:border-primary/50' : ''}`}
    >
      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded ${TONES[tone]}`}>
        <Icon size={17} />
      </span>
      <span className="min-w-0">
        <span className="stat-label block">{label}</span>
        <span className="stat-value block tabular-nums">{value}</span>
        {hint && <span className="block text-2xs text-muted">{hint}</span>}
      </span>
    </Tag>
  )
}
